var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Button, Checkbox, DialogActions, FormControlLabel, TextField } from '@mui/material';
import { SportIds } from 'common/const/sport-ids.const';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { Sports } from 'common/enums/sport/sports.enum';
import { CREATE_COMMUNITY } from 'common/graphql/mutations/community/create-community';
import { COMMUNITIES } from 'common/graphql/queries/community/communities';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import { createCommunityValidationSchema } from 'common/validationSchemas/communityValidationSchema';
import SportSelect from 'components/Select/SportSelect';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
import history from 'store/history';
var CreateCommunityDialog = function (_a) {
    var handleClose = _a.handleClose;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var createCommunity = function (data) {
        return useMutation(CREATE_COMMUNITY, {
            variables: {
                createCommunityData: __assign({}, data)
            },
            awaitRefetchQueries: true,
            refetchQueries: [COMMUNITIES]
        });
    };
    var handleChangeWrapper = function (e) {
        formik.setFieldError(e.target.name, undefined); // <- reset error on the field
        formik.handleChange(e); // <- call original Formik's change handler
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var onSuccess = function (responseData) {
        var _a;
        if ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.createCommunity) === null || _a === void 0 ? void 0 : _a.url) {
            dispatch(openSnackbar({
                message: t('Сообщество создано'),
                severity: SnackbarSeverity.SUCCESS
            }));
            history.push("/community/".concat(responseData.createCommunity.url));
            handleClose();
        }
    };
    var handleExecuteMutation = useDynamicMutation(createCommunity, onSuccess, onError).handleExecuteMutation;
    var handleSubmit = function (data) {
        handleExecuteMutation({
            name: data.name,
            isPrivate: data.isPrivate,
            sportIds: [SportIds[data.sport]]
        });
    };
    var formik = useFormik({
        initialValues: { name: '', sport: Sports.Run, isPrivate: false },
        validationSchema: createCommunityValidationSchema,
        onReset: handleClose,
        onSubmit: handleSubmit,
        validateOnChange: false,
        validateOnBlur: false
    });
    return (_jsxs("form", __assign({ onSubmit: formik.handleSubmit, onReset: formik.handleReset }, { children: [_jsxs("div", __assign({ className: "flex flex-col p-0 pb-20" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Создать сообщество') }), void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-10 items-center" }, { children: [_jsx(TextField, { className: "w-full", label: t('Name1'), name: "name", value: formik.values['name'], onChange: handleChangeWrapper, error: Boolean(formik.errors['name']), helperText: formik.errors['name'] }, void 0), _jsx(SportSelect, { value: formik.values['sport'], handleChange: formik.setFieldValue, disableClearable: false, errorMessage: t(formik.errors['sport'] || ''), name: "sport" }, void 0), _jsx(FormControlLabel, { className: "dark:text-white", control: _jsx(Checkbox, { checked: formik.values['isPrivate'] || false, onChange: function (e) {
                                        formik.setFieldError('isPrivate', undefined);
                                        formik.setFieldValue('isPrivate', e.target.checked);
                                    } }, void 0), label: t('Приватное сообщество') }, void 0)] }), void 0)] }), void 0), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ variant: "text", type: "reset", onClick: handleClose }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit" }, { children: t('Создать') }), void 0)] }), void 0)] }), void 0));
};
export default CreateCommunityDialog;
